import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "spinner"
};
const _hoisted_2 = { style: { "position": "absolute", "top": "50%", "left": "50%", "transform": "translate(-50%, -50%)" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.mode === 'spinner')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("div", { class: "bounce1" }, null, -1),
                        _createElementVNode("div", { class: "bounce2" }, null, -1),
                        _createElementVNode("div", { class: "bounce3" }, null, -1)
                    ]))]))
                : _renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isActive)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.class),
                    style: { "position": "absolute", "height": "100%", "width": "100%", "z-index": "1025" }
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(['g-loader', 'g-loader-' + _ctx.color, (_ctx.sizeMode ? 'g-loader-' + _ctx.sizeMode : '')]),
                            style: _normalizeStyle({ width: _ctx.size })
                        }, null, 6)
                    ])
                ], 2))
                : _createCommentVNode("", true)
        ], 64));
}
